import {NavDropdown} from "react-bootstrap";
import {useCallback, useState} from "react";
import {Loading} from "../Loading/Loading";
import HttpRequest from "../../Http/HttpRequest";
import Notify from "../../Notify/Notify";

export const NavItemTenant = () => {

    const [data, setData] = useState(null);

    const loadData = useCallback(() => {
        HttpRequest.get('node/auth/user-tenant-accesses')
            .then(data => setData(data))
            .catch(e => Notify.error("Falha ao carregar empresas", e))
    }, []);

    const changeTenant = (target) => {
        const {tenant} = target;
        HttpRequest.post(`node/auth/change-tenant/${tenant.id}`, {})
            .then(() => {
                Notify.success('Trocando de empresa..');
                setTimeout(() => {
                    window.location = '/?reloaded';
                }, 1000)
            })
            .catch(e => Notify.error('Falha ao trocar de empresa', e))
    }

    console.log('data', data)

    return (<NavDropdown onClick={loadData}
                         title={<i title="Trocar de entidade"
                                   className="fa fa-building"/>}>

        <Loading isLoading={!data}>

            {data?.map(x => <NavDropdown.Item key={x.id}
                                              onClick={(e) => e.preventDefault() || changeTenant(x)}>{x?.tenant?.name}</NavDropdown.Item>)}

        </Loading>
    </NavDropdown>)
}
